import React,{useEffect,useRef,useState} from 'react';
import {Alert,Button,Form,Modal,Spinner} from 'react-bootstrap';
import {authFetch} from '../utils/authFetch';
import {useAuth} from '../auth/AuthContext';

export default function SimausOfferPrint({offer}){
 const {user}=useAuth()||{};
 const canSend=!!user?.is_superuser||!!user?.perms?.includes('COMENZI_WRITE');
 const [pdf,setPdf]=useState(null),[error,setError]=useState(''),[message,setMessage]=useState('');
 const [show,setShow]=useState(false),[sending,setSending]=useState(false);
 const [mail,setMail]=useState({to_email:'',subject:'',body:''});
 const inFlight=useRef(false);
 useEffect(()=>{
  let active=true,url;
  setPdf(null);setError('');
  authFetch(`/oferte/${offer.id}/pdf`,{responseType:'blob'}).then(async blob=>{
   const bytes=await blob.arrayBuffer();
   const hash=Array.from(new Uint8Array(await window.crypto.subtle.digest('SHA-256',bytes))).map(x=>x.toString(16).padStart(2,'0')).join('');
   if(active){url=URL.createObjectURL(blob);setPdf({url,hash});}
  }).catch(e=>{if(active)setError(e.message);});
  return()=>{active=false;if(url)URL.revokeObjectURL(url);};
 },[offer.id,offer.version]);
 const openMail=()=>{
  setMail({to_email:offer.customer_email||'',subject:`Preisangebot / Ofertă ${offer.number}`,body:`Bună ziua,\n\nVă transmitem atașat oferta nr. ${offer.number}.\n\nCu stimă,\nSIMAUSROM`});
  setError('');setShow(true);
 };
 const send=async e=>{
  e.preventDefault();if(inFlight.current||!pdf)return;
  inFlight.current=true;setSending(true);setError('');setMessage('');
  try{
   const r=await authFetch(`/oferte/${offer.id}/send-email`,{method:'POST',body:{...mail,to_email:mail.to_email.trim(),version:offer.version,pdf_sha256:pdf.hash}});
   setMessage(r.message||'Emailul a fost acceptat de serverul de mail.');setShow(false);
  }catch(e){setError(e.message||'Trimiterea nu a putut fi confirmată. Verificați înainte de retrimitere.');}
  finally{inFlight.current=false;setSending(false);}
 };
 return <main className="container-fluid p-3">
  <h2>Ofertă {offer.number} — SIMAUS</h2>
  <div className="d-flex gap-2 mb-3">
   <Button as="a" href={pdf?.url} target="_blank" rel="noopener noreferrer" disabled={!pdf}>Deschide PDF / tipărește</Button>
   <Button as="a" href={pdf?.url} download={`oferta_${offer.id}.pdf`} variant="outline-secondary" disabled={!pdf}>Descarcă PDF</Button>
   {canSend&&<Button variant="outline-primary" disabled={!pdf||sending} onClick={openMail}>Trimite mail</Button>}
  </div>
  {message&&<Alert variant="success">{message}</Alert>}
  {!show&&error&&<Alert variant="danger">{error}</Alert>}
  {pdf?<iframe title="Oferta SIMAUS PDF" src={pdf.url} style={{width:'100%',height:'80vh',border:'1px solid #ddd'}}/>:!error&&<Spinner aria-label="Se pregătește PDF-ul"/>}
  <Modal show={show} onHide={()=>!sending&&setShow(false)} backdrop={sending?'static':true} keyboard={!sending}>
   <Form onSubmit={send}>
    <Modal.Header closeButton={!sending}><Modal.Title>Trimite oferta prin mail</Modal.Title></Modal.Header>
    <Modal.Body>
     {error&&<Alert variant="danger">{error}</Alert>}
     <Form.Group className="mb-3" controlId="offer-recipient"><Form.Label>Către</Form.Label><Form.Control type="email" required maxLength={254} disabled={sending} value={mail.to_email} onChange={e=>setMail({...mail,to_email:e.target.value})}/><Form.Text>Adresa poate fi schimbată doar pentru această trimitere. Nomenclatorul clientului rămâne neschimbat.</Form.Text></Form.Group>
     <Form.Group className="mb-3" controlId="offer-subject"><Form.Label>Subiect</Form.Label><Form.Control required maxLength={200} disabled={sending} value={mail.subject} onChange={e=>setMail({...mail,subject:e.target.value})}/></Form.Group>
     <Form.Group className="mb-3" controlId="offer-body"><Form.Label>Mesaj</Form.Label><Form.Control as="textarea" rows={6} maxLength={10000} disabled={sending} value={mail.body} onChange={e=>setMail({...mail,body:e.target.value})}/></Form.Group>
     <p>Atașament: <strong>oferta_{offer.id}.pdf</strong> — același PDF ca în previzualizare.</p>
    </Modal.Body>
    <Modal.Footer><Button variant="secondary" disabled={sending} onClick={()=>setShow(false)}>Renunță</Button><Button type="submit" disabled={sending||!pdf}>{sending?'Se trimite…':'Trimite oferta'}</Button></Modal.Footer>
   </Form>
  </Modal>
 </main>;
}
